var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7188 0.671875C13.0501 0.677107 8.57408 2.53405 5.27282 5.83532C1.97155 9.13658 0.114607 13.6126 0.109375 18.2812V33.4343C0.109851 34.0856 0.368795 34.7101 0.829342 35.1707C1.28989 35.6312 1.91439 35.8901 2.5657 35.8906H17.7188C22.389 35.8906 26.8681 34.0354 30.1705 30.733C33.4729 27.4306 35.3281 22.9515 35.3281 18.2812C35.3281 13.611 33.4729 9.13194 30.1705 5.82954C26.8681 2.52714 22.389 0.671875 17.7188 0.671875ZM17.7188 33.7344H2.5657C2.48612 33.7344 2.40979 33.7028 2.35352 33.6465C2.29724 33.5902 2.26562 33.5139 2.26562 33.4343V18.2812C2.26562 15.2249 3.17194 12.2372 4.86995 9.69595C6.56796 7.1547 8.98141 5.17403 11.8051 4.00442C14.6288 2.83481 17.7359 2.52879 20.7335 3.12505C23.7311 3.72131 26.4846 5.19308 28.6458 7.35424C30.8069 9.5154 32.2787 12.2689 32.8749 15.2665C33.4712 18.2641 33.1652 21.3712 31.9956 24.1949C30.826 27.0186 28.8453 29.432 26.304 31.1301C23.7628 32.8281 20.7751 33.7344 17.7188 33.7344Z",
    fill: "url(#paint0_linear_2947_5822)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2947_5822",
    x1: 17.7188,
    y1: 0.671875,
    x2: 17.7188,
    y2: 35.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#037FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD64D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.0b77daba4301d3943338df2db592c561.svg";
export { ForwardRef as ReactComponent };